import styled from '@emotion/styled';
import { format } from 'date-fns';

import { Player } from 'modules/players/domain/interfaces/player';
import { USER_DEFAULT_AVATAR } from 'shared/constants/links';
import { getBirthDay, getFullName } from 'shared/utils';
import { theme } from 'styles/theme/theme';
import { UDText } from 'ud-ui/components';

/**
 * Опция селекта игроков. В `value` лежит сам игрок — карточка под селектом рисуется
 * прямо из него, поэтому дата рождения здесь уже приведена к виду «дд.ММ.гггг».
 */
export interface PlayerSelectOption {
  label: React.ReactNode;
  value: Player;
}

const PlayerItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;

  & img {
    object-fit: cover;
    width: 40px;
    height: 40px;
    border-radius: 8px;
  }
`;

interface PlayerOptionProps {
  player?: Player;
}

export const PlayerOption = ({ player }: PlayerOptionProps) => {
  const fullName = player ? getFullName(player) : undefined;
  const birthDate = player
    ? getBirthDay({
        birthDate: new Date(player.birthDate ?? ''),
        fallback: undefined,
      })
    : undefined;

  return (
    <PlayerItem>
      <img src={player?.photo?.externalUrl ?? USER_DEFAULT_AVATAR} alt={player?.name ?? ''} />
      <UDText type="subhead" color={theme.colors.Black} className="truncate" title={fullName}>
        {fullName}
      </UDText>
      {birthDate && (
        <UDText type="subhead" color={theme.colors.WhiteGray} className="truncate" title={birthDate}>
          {birthDate}
        </UDText>
      )}
    </PlayerItem>
  );
};

export const playerToPlayerOption = (player: Player): PlayerSelectOption => ({
  label: <PlayerOption player={player} />,
  value: {
    ...player,
    birthDate: player.birthDate ? format(new Date(player.birthDate), 'dd.MM.yyyy') : undefined,
  },
});
